import React, { useEffect, useState } from "react";
import {
  SFTypography,
  SFUseStyled,
  SFStack,
  HighlightText,
  SFIcons,
  SFIconButton,
} from "@sf-core";

const { styled } = SFUseStyled();

const StyledStack = styled(SFStack)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.palette.grey200.main,
  maxHeight: "30px",
}));

const CustomGroupCell = (props) => {
  let filterModel = props.api.getFilterModel();
  const [rowExpanded, setRowExpanded] = useState(false);

  const toggleRows = () => {
    if (!props.context.allowMultipleDetailRows) {
      props.api.forEachNode((node) => node.setExpanded(false));
    }
    props.node.setExpanded(!rowExpanded);

  };

  useEffect(() => {
    if (props.node.expanded) {
      setRowExpanded(true);
    }
    else {
      setRowExpanded(false);
    }
  }, [props.node.expanded]);

  return (
    <StyledStack direction="row" justifyContent="flex-start" alignItems="center">
      <SFIconButton variant="transparent" onClick={toggleRows}>
        {rowExpanded ? (
          <SFIcons.SFArrowUpIcon />
        ) : (
          <SFIcons.SFArrowDownIcon />
        )}
      </SFIconButton>
      <SFTypography variant="body1">
        {Object.prototype.hasOwnProperty.call(filterModel, "searchText")
          ? HighlightText(
            props.value,
            JSON.parse(filterModel.searchText.filter).value
          )
          : props.value}
      </SFTypography>
    </StyledStack>
  );
};

export default CustomGroupCell;
